import React from 'react';
import About from '../components/sections/About';
import OpsPillars from '../components/sections/OpsPillars';
import Team from '../components/sections/Team';
import Colophon from '../components/sections/Colophon';
import SEO from '../components/SEO';
import '../styles/Sobre.css';

const Sobre: React.FC = () => (
  <div className="sobre">
    <SEO
      title="Sobre Nós | Patinhas Sem Lar"
      description="Conheça a missão da Patinhas Sem Lar e o trabalho de proteção animal."
      path="/sobre"
    />
    <About />
    <OpsPillars />
    <Team />
    <Colophon />
  </div>
);

export default Sobre;
